import axios from 'axios';

const API = {

    server(){
        return window.location.protocol + '//' + window.location.hostname
    },

    url(path){
        return this.server() + '/api/v2' + path
    },

    async get(path, options){
        const url = API.url(path);
        return await axios.get(url, options);
    },

    async post(path, data, options){
        const url = API.url(path);
        return await axios.post(url, data, options);
    },

    async put(path, data, options){
        const url = API.url(path);
        return await axios.put(url, data, options);
    },

    async delete(path, options){
        const url = API.url(path);
        return await axios.delete(url, options);
    },
    
    async download(path, fileName){

        const url = API.url(path);

        const name = fileName || ('doc' + Date.now());

        try{
            const r = await axios({url: url, method: 'GET', responseType: 'blob'});

            const href = URL.createObjectURL(r.data);
        
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        
            document.body.removeChild(link);
            URL.revokeObjectURL(href);

            return r;

        }catch(e){
            console.error(e);

            throw new Error("Failed to download file");
        }
    },

    async downloadAsFile(path, fileName){

        const url = API.url(path);

        const name = fileName || ('doc' + Date.now());

        try{
            const r = await axios({url: url, method: 'GET', responseType: 'blob'});

            const blob = r.data;

            const file = new File([blob], name);

            return file;

        }catch(e){
            console.error(e);

            throw new Error("Failed to download file");
        }
    },

    async downloadInUrl(path){
        const url = API.url(path);
        const response = await axios.get(url, {responseType: 'blob'});
        const blob = new Blob([response.data], {type: response.headers['content-type']});
        return window.URL.createObjectURL(blob);
    },

    async upload(path, file){
        const url = API.url(path);
        let data = file;
        if(!(file instanceof FormData)){
            data = new FormData();
            data.append('file', file);
        }
        return await axios.post(url, data, {headers: {'Content-Type': 'multipart/form-data'}});
    },

};


export default API;